const a = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" aria-hidden="true"><path fill-rule="evenodd" d="M13 3.75A2.25 2.25 0 0 0 10.75 6v10.5a.75.75 0 0 0 1.5 0V9.25a.75.75 0 0 1 1.5 0v7.25a2.25 2.25 0 0 1-4.5 0V6a3.75 3.75 0 1 1 7.5 0v10.5a5.25 5.25 0 1 1-10.5 0V9.25a.75.75 0 0 1 1.5 0v7.25a3.75 3.75 0 1 0 7.5 0V6A2.25 2.25 0 0 0 13 3.75" clip-rule="evenodd"/></svg>';
export {
  a as w
};
